// extracted by mini-css-extract-plugin
module.exports = {"body":"reportModalBody_body__22SM4","title":"reportModalBody_title__2DETC","description":"reportModalBody_description__3cM6y"};